export default "__VITE_ASSET__CtaSQgUV__"